import { createContext, useReducer, useContext } from "react";

const State = {
  showLeftNav: false,
  showSupportReq: false,
  showAddPopup: false,
  authenticated: true,
  hiddenLeftbarWhenShowForms: false,
};

const reducer = (state = State, action) => {
  const { type, payload } = action;
  switch (type) {
    case "toggle_hiddenLeftbarWhenShowForms":
      return {
        ...state,
        hiddenLeftbarWhenShowForms: !state.hiddenLeftbarWhenShowForms,
      };

    case "set_authenticated":
      return { ...state, authenticated: true };

    case "toggle_addpopup":
      return { ...state, showAddPopup: !state.showAddPopup };

    case "toggle_support_req":
      return { ...state, showSupportReq: !state.showSupportReq };

    case "toggle_left_nav":
      return { ...state, showLeftNav: !state.showLeftNav };
    default:
      return state;
  }
};

const RootContext = createContext();

const RootProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, State);
  return (
    <RootContext.Provider value={{ state, dispatch }}>
      {children}
    </RootContext.Provider>
  );
};

const useRootContext = () => useContext(RootContext);

export { RootProvider, useRootContext };
